<!--
/*
 * @Description: login组件容器
 * @Author: Guojun
 * @Date: 2020-05-19 14:43:48
 * @LastEditTime: 2020-5-20 09:02:47
 */
  -->
<template>
  <div class="comLogin">
    <ul class="title">
      <li
        v-for="(item,index) in tabs"
        :class="index==activeTab?'activeTab':''"
        :key="index"
        @click="tabsClick(index)"
      >{{item}}</li>
    </ul>
    <div class="middle">
      <div v-if="!phoneFirstLogin">
        <phone-login ref="phoneLogin" v-if="activeTab==0"></phone-login>
        <password-login ref="passwordLogin" v-if="activeTab==1"></password-login>
      </div>
      <div v-if="phoneFirstLogin">
        <password-login v-if="activeTab==1"></password-login>
        <setPhone-login v-if="activeTab==0"></setPhone-login>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import phoneLogin from "./phoneLogin.vue";
import passwordLogin from "./passwordLogin.vue";
import setPhoneLogin from "./setPhoneLogin";
import Verify from "./verifition/Verify";
export default {
  data() {
    return {
      activeTab: 0,
      tabs: ["手机快捷登录", "账号密码登录"],
      area: "86",
      isVerify: false,
      captchaVerification: "",
      phoneFirstLogin: false,
      show: true,
    };
  },
  created() {
    this.$EventBus.$on("firstLogin", (data) => {
      this.phoneFirstLogin = data;
    });
  },
  beforeDestroy() {
    this.$EventBus.$off("firstLogin");
  },
  mounted() {},
  methods: {
    tabsClick(index) {
      this.activeTab = index;
    },
  },
  components: {
    phoneLogin,
    passwordLogin,
    setPhoneLogin,
    Verify,
  },
};
</script>
 
<style lang="less" scoped>
.comLogin {
  width: 300px;
  margin: 0 auto;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 70px;
    font-size: 18px;
    color: #333;
    position: relative;
    li {
      flex-basis: 50%;
      border-bottom: 1px solid #e9e9f0;
      line-height: 45px;
      text-align: center;
      cursor: pointer;
    }
    .activeTab {
      border-bottom: 2px solid #fabe00;
      color: #fabe00;
      font-weight: bold;
    }
    .icon_close {
      position: absolute;
      cursor: pointer;
      right: -90px;
      top: -64px;
      font-size: 30px;
    }
  }
  .middle {
    margin-top: 54px;
  }
}
</style>